/*global $, jQuery*/

"use strict";

$(document).ready(function () {

    controlTopMenu();
    detectSeenElements();
    initSpotlight();
    initScrollSpy();

    // Modals are native <dialog>. showModal() gives the backdrop, Esc-to-close,
    // focus trapping and inert background that Materialize's modal was carrying
    // 170KB of framework to approximate.
    $('.modal-trigger').on('click', function (e) {
        e.preventDefault();
        var dialog = document.querySelector($(this).attr('href'));
        if (dialog) {
            dialog.showModal();
        }
    });

    $('.modal-close, .modal__cross').on('click', function (e) {
        e.preventDefault();
        this.closest('dialog').close();
    });

    // Click outside the panel closes it. The dialog element fills the viewport
    // for hit-testing, so compare against its content box.
    $('dialog.modal').on('click', function (e) {
        if (e.target !== this) {
            return;
        }
        var box = this.getBoundingClientRect();
        var outside = e.clientX < box.left || e.clientX > box.right ||
                      e.clientY < box.top || e.clientY > box.bottom;
        if (outside) {
            this.close();
        }
    });

    $('.animated-scroll').on('click', function (e) {
        e.preventDefault();
        var linkHref = $(this).attr('href');
        $('html, body').animate({
            scrollTop: $(linkHref).offset().top - 120
        }, 500);
    });

    function controlTopMenu() {
        function toggle() {
            $('.top-menu').toggleClass('not-top', $(window).scrollTop() > 0);
        }

        toggle();
        $(window).on('scroll', toggle);
    }

    // IntersectionObserver, not a scroll handler. It replaces both the old
    // measure-every-section-on-every-scroll pass and the two-frame rAF hack
    // that pass needed: IO's first callback is dispatched after layout but
    // after the initial paint, so the opacity-0 start state is on screen for a
    // frame and the transition actually runs. It also self-unsubscribes, so no
    // work is left once everything has been revealed.
    function detectSeenElements() {
        var $sections = $('.animation-section, .animated-block');

        if (!('IntersectionObserver' in window)) {
            // No IO: show everything. The alternative is a page stuck at
            // opacity 0, which is worse than no animation.
            $sections.addClass('seen');
            return;
        }

        var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) {
                    return;
                }
                entry.target.classList.add('seen');
                io.unobserve(entry.target);
            });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });

        $sections.each(function () {
            io.observe(this);
        });
    }

    // Cursor spotlight. Writes --mx/--my, which the .ap-spot::before gradient
    // in atmosphere.styl reads.
    function initSpotlight() {
        var els = document.querySelectorAll('.ap-spot');

        for (var i = 0; i < els.length; i++) {
            bindSpot(els[i]);
        }

        function bindSpot(el) {
            var queued = false;
            var cx = 0;
            var cy = 0;

            el.addEventListener('mousemove', function (event) {
                cx = event.clientX;
                cy = event.clientY;

                if (queued) {
                    return;
                }
                queued = true;

                // One read and one write per frame. A trackpad emits mousemove
                // well above 60/s, and a getBoundingClientRect on each of them
                // forces a synchronous layout every time.
                requestAnimationFrame(function () {
                    queued = false;
                    var box = el.getBoundingClientRect();
                    el.style.setProperty('--mx', (cx - box.left) + 'px');
                    el.style.setProperty('--my', (cy - box.top) + 'px');
                });
            });
        }
    }

    // Marks the nav link for whichever section is crossing the middle of the
    // viewport. The .active styling already existed but nothing ever set it.
    function initScrollSpy() {
        if (!('IntersectionObserver' in window)) {
            return;
        }

        var links = {};
        $('.top-menu-link.animated-scroll').each(function () {
            var href = $(this).attr('href') || '';
            if (href.charAt(0) === '#' && href.length > 1) {
                links[href.slice(1)] = this;
            }
        });

        var ids = Object.keys(links);
        if (!ids.length) {
            return;
        }

        // Recomputed from the full intersecting set rather than from whichever
        // entry arrived last. Acting only on isIntersecting entries left the
        // previous link lit when the band moved onto the hero, which has no
        // nav link of its own — so scrolling back to the top still showed
        // "Contacts" as current.
        var intersecting = {};

        var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                intersecting[entry.target.id] = entry.isIntersecting;
            });

            var activeId = null;
            for (var i = 0; i < ids.length; i++) {
                if (intersecting[ids[i]]) {
                    activeId = ids[i];
                    break;
                }
            }

            ids.forEach(function (id) {
                links[id].classList.toggle('active', id === activeId);
            });
        // A thin band across the middle of the viewport, so at most one
        // section is current at a time.
        }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });

        ids.forEach(function (id) {
            var section = document.getElementById(id);
            if (section) {
                io.observe(section);
            }
        });
    }

});

gdprCookieNotice({
    locale: 'en', //This is the default value
    timeout: 500, //Time until the cookie bar appears
    expiration: 60, //This is the default value, in days
    domain: 'avis.partners', //If you run the same cookie notice on all subdomains, define the main domain starting with a .
    implicit: false, //Accept cookies on page scroll automatically
    statement: '#', //Link to your cookie statement page
    performance: ['JSESSIONID', '_hjIncludedInSample', 'nQ_visitId', 'nQ_cookieId', 'locale', 'lang', '__atuvc', '__hstc', '__hssrc', '__hssc', 'hsfirstvisit', 'hubspotutk'], //Cookies in the performance category.
    analytics: ['ga', '_ga', '_gid', '_gat', 'collect', '_ga_user_id', '__utmz', '__utma', 'gwcc'], //Cookies in the analytics category.
    marketing: ['SSID', 'IDE', 'test_cookie', 'fr', 'tr', '1P_JAR', 'id', 'NID', 'APISID', 'SAPISID', 'guest_id', 'personalization_id', 'bcookie', 'bscookie', 'lidc', 'MUID', 'MUIDB', 'GPS'] //Cookies in the marketing category.
});
